import { createSelectField } from 'components/fields/createSelectField';
import type { Vendor } from './types';

export const vendorFieldProps = {
  getOptionLabel: ({ name }: Vendor) => name,
  formatOptionLabel: ({ name }: Vendor) => name,
  getOptionValue: (a: Vendor) => a.id.toString(),
};

export const VendorField = createSelectField<Vendor>('supplier/vendors/', {
  ...vendorFieldProps,
  suggestion: true,
});
